import { TextField } from 'material-ui';
import { TextFieldProps } from 'material-ui';
import * as React from 'react';

export default class FIATextField extends React.Component<TextFieldProps> {

    public render() {
        return (
            <TextField
                {...this.props}
                floatingLabelStyle={{ color: '#ccc', fontWeight:300 }}
                underlineStyle={{ borderColor: '#000' }}
                underlineFocusStyle={{ borderColor: '#000' }}
            />)
    }

} 


// WEBPACK FOOTER //
// ./src/app/abstract/Views/TextField.tsx